
      var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCodeNotReceivedVoiseIcn = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#codeNotReceivedVoiseIcn_34423580414d1d48__a)",
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.826 12.848a.716.716 0 0 0-1.431 0 6.356 6.356 0 0 1-6.349 6.35 6.356 6.356 0 0 1-6.349-6.35.716.716 0 0 0-1.431 0c0 4.05 3.108 7.385 7.064 7.748v1.926H8.674a.716.716 0 0 0 0 1.432h6.744a.716.716 0 0 0 0-1.432h-2.656v-1.926c3.956-.363 7.064-3.699 7.064-7.748Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.046 17.43a4.588 4.588 0 0 0 4.583-4.582V4.536a4.588 4.588 0 0 0-4.583-4.583 4.588 4.588 0 0 0-4.583 4.583v8.312a4.588 4.588 0 0 0 4.583 4.583ZM8.894 4.537a3.155 3.155 0 0 1 3.152-3.151 3.155 3.155 0 0 1 3.151 3.15v8.313a3.155 3.155 0 0 1-3.151 3.151 3.155 3.155 0 0 1-3.152-3.151V4.536Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "codeNotReceivedVoiseIcn_34423580414d1d48__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<g clip-path=\"url(#clip0_8897_6590)\">\r\n<path d=\"M19.8265 12.8484C19.8265 12.4532 19.5061 12.1328 19.1107 12.1328C18.7154 12.1328 18.395 12.4532 18.395 12.8484C18.395 16.3494 15.547 19.1974 12.046 19.1974C8.54517 19.1974 5.69715 16.3494 5.69715 12.8484C5.69715 12.4532 5.37671 12.1328 4.98139 12.1328C4.58606 12.1328 4.26562 12.4532 4.26562 12.8484C4.26562 16.8974 7.3744 20.233 11.3302 20.5956V22.5224H8.67408C8.27876 22.5224 7.95832 22.8429 7.95832 23.2382C7.95832 23.6335 8.27876 23.9539 8.67408 23.9539H15.4181C15.8132 23.9539 16.1336 23.6335 16.1336 23.2382C16.1336 22.8429 15.8132 22.5224 15.4181 22.5224H12.7617V20.5956C16.7177 20.2332 19.8265 16.8974 19.8265 12.8484Z\" fill=\"black\"/>\r\n<path d=\"M12.0457 17.4306C14.5727 17.4306 16.6286 15.3747 16.6286 12.8476V4.5359C16.6286 2.00904 14.5727 -0.046875 12.0457 -0.046875C9.5188 -0.046875 7.46289 2.00904 7.46289 4.5359V12.8476C7.46289 15.3747 9.5188 17.4306 12.0457 17.4306ZM8.89423 4.5359C8.89423 2.79822 10.308 1.38465 12.0457 1.38465C13.7833 1.38465 15.1971 2.79822 15.1971 4.5359V12.8476C15.1971 14.5853 13.7833 15.9991 12.0457 15.9991C10.308 15.9991 8.89423 14.5853 8.89423 12.8476V4.5359Z\" fill=\"black\"/>\r\n</g>\r\n<defs>\r\n<clipPath id=\"clip0_8897_6590\">\r\n<rect width=\"24\" height=\"24\" fill=\"white\"/>\r\n</clipPath>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/codeNotReceivedVoiseIcn.34423580414d1d48fff65d4cc07536c2.svg"),
        {
          React: SvgCodeNotReceivedVoiseIcn,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      